import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0225d034"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-padding activeTrackingTitle" }, "Aktuelles Tracking", -1))
const _hoisted_3 = { class: "activeTrackingCardHeaderSubTitle" }
const _hoisted_4 = { style: {"min-width":"60%","float":"left"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1))
const _hoisted_6 = { style: {"min-width":"40%","float":"left"} }
const _hoisted_7 = { style: {"padding-left":"15px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_current_position_to_user_location_dialog = _resolveComponent("add-current-position-to-user-location-dialog")!
  const _component_advanced_tracking_overlay = _resolveComponent("advanced-tracking-overlay")!
  const _component_WeatherIcon = _resolveComponent("WeatherIcon")!
  const _component_disabled_map = _resolveComponent("disabled-map")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_tracking_distance = _resolveComponent("tracking-distance")!
  const _component_tracking_duration = _resolveComponent("tracking-duration")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab_list = _resolveComponent("ion-fab-list")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return ($setup.hasActiveTracking)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_add_current_position_to_user_location_dialog, {
          "coordinate-to-check": $setup.coordinateToCheck,
          "show-dialog": $setup.showAddCurrentPositionToUserLocationDialog,
          onLocationAdded: _cache[0] || (_cache[0] = ($event: any) => ($setup.stopActiveTracking($event, false))),
          onCancel: _cache[1] || (_cache[1] = ($event: any) => ($setup.stopActiveTracking($event, true))),
          onLocationAddError: _cache[2] || (_cache[2] = ($event: any) => ($setup.stopActiveTracking($event, true)))
        }, null, 8, ["coordinate-to-check", "show-dialog"]),
        _withDirectives(_createVNode(_component_advanced_tracking_overlay, {
          onSelectTrackType: $setup.triggerTrack,
          onCloseOverlay: $setup.toggleShowMoreTypes
        }, null, 8, ["onSelectTrackType", "onCloseOverlay"]), [
          [_vShow, $setup.showMoreTypes === true]
        ]),
        _hoisted_2,
        _createVNode(_component_ion_card, { class: "activeTrackingCard" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([$setup.changeTrackButtonClicked ? 'back-drop-active-tracking' : '']),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleBackdropClick && $setup.handleBackdropClick(...args)))
            }, null, 2),
            _createVNode(_component_WeatherIcon, {
              "load-current-weather": false,
              weather: $setup.currentTracking.weatherItem,
              "use-current-tracking-latest-position": false
            }, null, 8, ["weather"]),
            _createVNode(_component_disabled_map, {
              disableMarkerUpdateEvent: true,
              zoom: 15,
              "street-view-control": false,
              "init-cords": {lat: $setup.getCurrentPosition.latitude, lng: $setup.getCurrentPosition.longitude},
              "show-path": true,
              height: "14em"
            }, null, 8, ["init-cords"]),
            _createVNode(_component_ion_card_header, { class: "activeTrackingCardHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "4.5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, { class: "activeTrackingCardHeaderTitle" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.trackingName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_ion_icon, {
                                  icon: $setup.icons.location
                                }, null, 8, ["icon"]),
                                _createVNode(_component_tracking_distance),
                                _hoisted_5
                              ]),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_ion_icon, {
                                  style: {"float":"left"},
                                  icon: $setup.icons.timeOutline
                                }, null, 8, ["icon"]),
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_tracking_duration)
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_content, { class: "activeTrackingCardHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: $setup.icons.location
                                }, null, 8, ["icon"]),
                                ($setup.startAddress && $setup.startAddress !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.startAddress.city), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "Unbekannt"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: $setup.currentTrackIcon }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.currentTrackingStateName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { style: {"padding-top":"15px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_grid, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, null, {
                                      default: _withCtx(() => [
                                        ($setup.hasActiveTrack)
                                          ? (_openBlock(), _createBlock(_component_ion_fab, {
                                              key: 0,
                                              class: _normalizeClass(['buttonsPosition', $setup.changeTrackButtonClicked ? 'showMoreTrackingTypeZIndexVisible' : 'showMoreTrackingTypeZIndexHidden']),
                                              activated: "false",
                                              edge: "",
                                              horizontal: "end",
                                              vertical: "bottom",
                                              ref: "fabButtonChangeTrackRef",
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTrackButtonClicked = !$setup.changeTrackButtonClicked))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_fab_button, {
                                                  class: _normalizeClass(['activeTrackingButton',  $setup.duration.toString().length > 5 ? 'smallFont' : '']),
                                                  color: "success"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      style: {"font-size":"50px"},
                                                      icon: $setup.currentTrackIcon
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["class"]),
                                                _createVNode(_component_ion_fab_list, {
                                                  side: "start",
                                                  class: "ion-padding-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getTrackingTypeMinimal_Data_Map(), (trackingTrackType) => {
                                                      return (_openBlock(), _createBlock(_component_ion_fab_button, {
                                                        key: trackingTrackType.code,
                                                        class: "trackFabButton trackFabIcon activeTrackingButton",
                                                        onClick: ($event: any) => ($setup.triggerTrack(trackingTrackType.code)),
                                                        style: _normalizeStyle(trackingTrackType.style)
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_icon, {
                                                            icon: trackingTrackType.getTrackTypeIcon(),
                                                            class: "track-fab-icon-size-sm"
                                                          }, null, 8, ["icon"])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick", "style"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_fab_list, { side: "top" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_fab_button, {
                                                      class: "activeTrackingButton moreTrackingTypeButtonPadding",
                                                      onClick: $setup.toggleShowMoreTypes
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, {
                                                          icon: $setup.icons.arrowUp
                                                        }, null, 8, ["icon"])
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                          : _createCommentVNode("", true),
                                        (!$setup.hasActiveTrack)
                                          ? (_openBlock(), _createBlock(_component_ion_fab, {
                                              key: 1,
                                              activated: "false",
                                              edge: "",
                                              class: _normalizeClass(['buttonsPosition', $setup.changeTrackButtonClicked ? 'showMoreTrackingTypeZIndexVisible' : 'showMoreTrackingTypeZIndexHidden']),
                                              horizontal: "end",
                                              vertical: "bottom",
                                              ref: "fabButtonChangeTrackRef",
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeTrackButtonClicked = !$setup.changeTrackButtonClicked))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_fab_button, {
                                                  class: _normalizeClass(['continueTrackingButton activeTrackingButton',  $setup.duration.toString().length > 5 ? 'smallFont' : '']),
                                                  color: "success"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      style: {"font-size":"50px","padding-left":"5px"},
                                                      icon: $setup.icons.playOutline
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["class"]),
                                                _createVNode(_component_ion_fab_list, { side: "start" }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(), _createBlock(_component_ion_fab_button, {
                                                      key: $setup.currentTrackingTrackType,
                                                      class: "trackFabButton trackFabIcon activeTrackingButton continueWithCurrentTrackType",
                                                      onClick: $setup.continueTracking
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_item, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_icon, {
                                                              size: "large",
                                                              icon: $setup.currentTrackIcon,
                                                              class: ""
                                                            }, null, 8, ["icon"]),
                                                            _createVNode(_component_ion_label, {
                                                              class: "ion-text-wrap continueCurrentTrackTypeFontSize",
                                                              style: {"margin-left":".5rem"}
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString($setup.getCurrentTrackingTrackTypeText()), 1)
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_ion_ripple_effect)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"]))
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_fab_list, { side: "top" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_fab_button, {
                                                      class: "activeTrackingButton moreTrackingTypeButtonPadding",
                                                      onClick: $setup.toggleShowMoreTypes
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, {
                                                          icon: $setup.icons.arrowUp
                                                        }, null, 8, ["icon"])
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                          : _createCommentVNode("", true),
                                        ($setup.hasActiveTrack)
                                          ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                                              key: 2,
                                              class: "stopActiveTrackingButton",
                                              color: "danger",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.stopActiveTracking($event, false)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  icon: $setup.icons.stop
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        ($setup.hasActiveTrack)
                                          ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                                              key: 3,
                                              class: "pauseActiveTrackingButton",
                                              color: "warning",
                                              onClick: $setup.pauseActiveTracking
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  icon: $setup.icons.pause
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}